var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg015Medal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m403.07 113.218c-31.816-68.775-101.323-113.218-177.07-113.218-107.52 0-195 87.48-195 195 0 38.979 16.187 68.584 31.846 97.192 14.472 26.485 28.154 51.49 28.154 82.808v137h135 75v-46c0-24.814 20.186-45 45-45h75v-96.728l60-32.358z",
    fill: "#697c86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 466c0-24.814 20.186-45 45-45h75v-96.728l60-32.358-77.93-178.696c-31.816-68.775-101.323-113.218-177.07-113.218v512h75z",
    fill: "#465a61"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m241 217.031h-15-15l-15 22.969v60l15 39.272 15-7.5 15 7.5 15-39.272v-60z",
    fill: "#e63950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 300v-60l-15-22.969h-15v114.741l15 7.5z",
    fill: "#ae2538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 217.031h-60v122.241l60 30z",
    fill: "#e63950"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m151 217.031v152.241l60-30v-122.241z",
    fill: "#f66"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 165,
    fill: "#ffea80",
    r: 105
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331 165c0-57.99-47.01-105-105-105v210c57.99 0 105-47.01 105-105z",
    fill: "#fabe2c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 165,
    fill: "#fabe2c",
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 165c0-24.853-20.147-45-45-45v90c24.853 0 45-20.147 45-45z",
    fill: "#ff9100"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg015Medal);
export default __webpack_public_path__ + "static/media/015-medal.f133d0cfdeaee8e28592feffd3bda35e.svg";
export { ForwardRef as ReactComponent };